import { UserProperties } from '../types';

export async function getUserProperties(): Promise<UserProperties> {
  const {
    account: { id: organizationId },
    user: { id: userId },
  } = VSS.getWebContext();

  return fetch('/actionable-agile/api/user-properties', {
    method: 'GET',
    headers: {
      'x-55d-org-id': organizationId,
      'x-55d-user-id': userId,
    },
  }).then((response) => response.json());
}
